import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { authHeaders } from "../utils/authHeaders";

const TYPES = [
  "video_pembelajaran",
  "video_tutorial",
  "panduan_pembelajaran",
  "e_book",
  "panduan_fasilitasi",
  "materi_presentasi",
  "flipchart"
];

export default function AddCoursePopup({ competencies, userRole, onClose, onAdd }) {
  const [formData, setFormData] = useState({
    title: "",
    type: "",
    url: "",
    competency_id: "",
    test_questions: ""
  });

  const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        title: formData.title,
        type: formData.type,
        url: formData.url,
        competency_id: formData.competency_id || null,
        test_questions: formData.test_questions ? JSON.parse(formData.test_questions) : null
      };

      const response = await fetch(`${apiUrl}/courses`, {
        method: "POST",
        headers: authHeaders({ role: userRole }, { "Content-Type": "application/json" }),
        body: JSON.stringify(payload)
      });

      const data = await response.json();
      if (data.success) {
        onAdd({
          id: data.id,
          ...payload,
          competency_name: competencies.find((c) => String(c.id) === String(payload.competency_id))?.name,
        });
        onClose();
      } else {
        alert("Gagal menambahkan kursus: " + (data.message || "Error"));
      }
    } catch (error) {
      console.error("Add course error:", error);
      alert("Terjadi kesalahan.");
    }
  };

  return (
    <div className="modal-overlay add-course-overlay">
      <div className="modal-content add-course-modal">
        <div className="modal-header">
          <h3>Tambah Konten Kursus</h3>
          <button onClick={onClose} className="close-btn">
            <FaTimes />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="add-form add-course-form">
          <div className="add-course-fields">
            <label className="form-field">
              <span>Judul Kursus</span>
              <input
                type="text"
                placeholder="Masukkan judul kursus"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                required
              />
            </label>

            <label className="form-field">
              <span>Jenis Konten</span>
              <select
                value={formData.type}
                onChange={(e) => setFormData({ ...formData, type: e.target.value })}
                required
              >
                <option value="">Pilih Jenis Konten</option>
                {TYPES.map((type) => (
                  <option key={type} value={type}>
                    {type.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase())}
                  </option>
                ))}
              </select>
            </label>

            <label className="form-field">
              <span>URL Konten</span>
              <input
                type="url"
                placeholder="YouTube untuk video, link PDF/PPT untuk materi"
                value={formData.url}
                onChange={(e) => setFormData({ ...formData, url: e.target.value })}
                required
              />
            </label>

            <label className="form-field">
              <span>Kompetensi (Opsional)</span>
              <select
                value={formData.competency_id}
                onChange={(e) => setFormData({ ...formData, competency_id: e.target.value })}
              >
                <option value="">Pilih Kompetensi (Opsional)</option>
                {competencies.map((comp) => (
                  <option key={comp.id} value={comp.id}>
                    {comp.name}
                  </option>
                ))}
              </select>
            </label>

            <label className="form-field">
              <span>Soal Tes (JSON, Opsional)</span>
              <textarea
                placeholder='Contoh: [{"question":"Q1?","options":["A","B"],"correct":0}]'
                value={formData.test_questions}
                onChange={(e) => setFormData({ ...formData, test_questions: e.target.value })}
                rows={6}
              />
            </label>
          </div>

          <div className="modal-actions">
            <button type="button" onClick={onClose}>Batal</button>
            <button type="submit">Tambah</button>
          </div>
        </form>
      </div>
    </div>
  );
}

